module.exports = __webpack_public_path__ + "static/img/2456_phase_function_Paper_PointsHejduk_Prediction.6e500b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2456_phase_function_Paper_PointsHejduk_Prediction.png
// module id = kYT5
// module chunks = 0